import { events } from "@grindex-common/helpers/events";
import TabNames from "@grindex-client/components/Tabs/TabNames.class";
import asyncModule from "@grindex-client/components/Module/asyncModule";

import DocumentsApiBase from "./DocumentsApi.class";

(function listenForEvent() {
	asyncModule("sensusDocuments", events.tabLoadedEvent(new TabNames().product.documentation), init);
})();

function init($view) {
	const $module = $view;

	const searchString = $module.dataset.apiQuery;

	if (!searchString) {
		return;
	}

	const apiUrl = `/api/sensusdocuments/search/?searchQuery=${searchString}`;

	const documentLoader = new DocumentsApiBase($view, apiUrl);

	documentLoader.run();
}

export default {
	view: "sensusDocuments",
	init,
};
